export enum BillSourceType {
    InheritParent = 'SameWithParent',
    VariablesExpression = 'VariablesExpression',
    AutoCreation = 'AutoGenerateDownBill',
}